import React from "react";
import MainInventoryList from "../../../commons/Inventory/InventoryList";

const Inventory = () => {
  return (
    <>
      <MainInventoryList />
    </>
  );
};

export default Inventory;
